export default __webpack_public_path__ + "static/logo-6c1b59c1169f23623cc0312d91d0356f.png";